import $ from 'jquery';
import Offcanvas from "bootstrap/js/src/offcanvas.js";
import Modal from "bootstrap/js/src/modal.js";
import gsap from "gsap";
import Carousel from "./carousel.js";
import FeedbackForm from "./feedback-form.js";
import TasksCarousel from './tasks.js';
import Header from './header.js';
import Animation from './animation.js';

$(function () {
    window.bootstrap = {Modal, Offcanvas};
    gsap.defaults({duration: .5});
    gsap.config({nullTargetWarn: false})
    
    new Carousel({
        id: 'js-partners-carousel',
        containerSelector: '.js-partners-container',
        controlsSelector: '.js-partners-controls',
        controlAttr: 'data-carousel-control'
    }).init();

    new Carousel({
        id: 'js-media-carousel',
        containerSelector: '.js-media-container',
        controlsSelector: '.js-media-controls',
        controlAttr: 'data-carousel-control'
    }).init();

    new TasksCarousel().init();
    // CAROUSELS END


    $('.js-phone-mask').mask('+7 (999) 999-99-99', {autoclear: false});
    // PHONE MASK END


    $.validator.addMethod('regexp', function(value, element, params) {
        const expression = new RegExp(params);
        
        return this.optional(element) || expression.test(value);
    });
    
    const fieldNames = {
        name: 'name',
        phone: 'phone',
        activity: 'sphere',
        email: 'email',
        message: 'message',
    };

    new FeedbackForm({
        formId: 'js-feedback-form',
        statusModalId: 'js-modal-status',
        validateOptions: {
            rules: {
                [fieldNames.name]: {
                    required: true,
                    regexp: /([а-яА-яa-zA-z]+\s)+([а-яА-яa-zA-z]+)/ig
                },
                [fieldNames.phone]: {
                    required: true,
                    minlength: 18,
                },
                [fieldNames.activity]:{
                    required: true,
                    minlength: 5
                },
                [fieldNames.email]: {
                    required: true,
                    email: true
                },
                [fieldNames.message]: {
                    required: true,
                    minlength: 15
                }
            },
            messages: {
                [fieldNames.name]: {
                    required: 'Укажите имя',
                    regexp: 'Должно быть не менее 2 слов'
                },
                [fieldNames.phone]: {
                    required: 'Укажите номер',
                    minlength: 'Некорретный формат'
                },
                [fieldNames.activity]:{
                    required: 'Укажите сферу деятельности',
                    minlength: 'Недостаточно символов'
                },
                [fieldNames.email]: {
                    required: 'Укажите email',
                    email: 'Некорректный email'
                },
                [fieldNames.message]: {
                    required: 'Укажите вопрос или предложение',
                    minlength: 'Недостаточно символов'
                }
            },
        }
    })
    // VALIDATION END


    new Header().init();
    // STICKY HEADER END

    new Animation().init();
    // ANIMATION END
});